var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHp5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "297mm",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "806.22 5163.88 19373.3 19373.3",
    width: "210mm",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#015294"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10492.87 5163.88c5349.79 0 9686.65 4336.86 9686.65 9686.65s-4336.86 9686.65-9686.65 9686.65c-179.31 0-357.38-5.24-534.29-14.87l2037.4-5722.16h2118.25c615.15 0 1262.41-503.3 1438.37-1118.46l1788.61-5023.44c363.13-1019.89-316.24-1621.47-1095.82-1623.7l-3489.94-1.06-4698.05 13194.77c-4170.88-1080.14-7251.18-4869.13-7251.18-9377.73 0-4603.04 3210.66-8456.14 7514.69-9442.01l-4656.94 13079.34h2005.88l2255.63-6335.09h1152.51l-2250.88 6321.74h2005.88l2070.89-5816.26c363.13-1019.89-316.23-1621.47-1095.82-1623.7l-1482.93-4.25 2088.41-5865.42c26.48-.21 52.81-1 79.33-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12394.22 17681.69 1968.59-5528.92h1152.51l-1968.6 5528.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp5);
export default __webpack_public_path__ + "static/media/hp-5.e434a31d8766919c9704cfcd4870a9f6.svg";
export { ForwardRef as ReactComponent };